<template>
  <div class="container">
    <el-card>
      <div slot="header">新增售水</div>
      <div class="centerBox">
        <el-form
          ref="sellWaterForm"
          :model="sellWaterForm"
          :rules="sellWaterFormRules"
        >
          <el-form-item label="选择商户名称：" prop="lesseeId">
            <el-select
              v-model="sellWaterForm.lesseeId"
              placeholder=""
              size="small"
              clearable
              filterable
              @change="lesseeIdChange"
            >
              <el-option
                v-for="item in merchantNameOptions"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>

        <div class="center_Con">
          <div class="content">
            <el-row :gutter="10">
              <el-col :md="8">
                商户编号：<span> {{ contentForm.code }} </span>
              </el-col>
              <el-col :md="8">
                商户联系人:<span> {{ contentForm.contactMan }} </span>
              </el-col>
              <el-col :md="8">
                电账户余额（元）:<span>
                  {{ contentForm.electricBalance }}
                </span>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :md="8">
                商户名称：<span> {{ contentForm.name }} </span>
              </el-col>
              <el-col :md="8">
                联系人电话:<span> {{ contentForm.phone }} </span>
              </el-col>
              <el-col :md="8">
                水账户余额（元）:<span> {{ contentForm.waterBalance }} </span>
              </el-col>
            </el-row>
          </div>
        </div>
        <div>
          <el-form
            ref="sellWaterForm"
            :model="sellWaterForm"
            :rules="sellWaterFormRules"
          >
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="收款金额（元）" prop="collectAmount">
                  <el-input
                    v-model="sellWaterForm.collectAmount"
                    clearable
                    oninput="value=value.replace(/[^.-\d]+/g, '').replace(/^0+(\d)/, '$1').replace('.','$#$').replace(/\./g,'').replace('$#$','.').replace('-', '$#$').replace(/\-/g, '').replace('$#$', '-').replace(/\.{2,}/g,'.').replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3')"
                    maxlength="11"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="售水金额" prop="money">
                  <el-input
                    v-model="sellWaterForm.money"
                    clearable
                    oninput="value=value.replace(/[^.-\d]+/g, '').replace(/^0+(\d)/, '$1').replace('.','$#$').replace(/\./g,'').replace('$#$','.').replace('-', '$#$').replace(/\-/g, '').replace('$#$', '-').replace(/\.{2,}/g,'.').replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3')"
                    maxlength="11"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="找零金额" prop="changeAmount">
                  <el-input
                    v-model="sellWaterForm.changeAmount"
                    clearable
                    disabled
                    onkeyup="value=value.replace(/[^\d{1,}\.\d{1,}|\d{1,}]/g,'').replace('.','$#$').replace(/\./g,'').replace('$#$','.').replace(/\.{2,}/g,'.').replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3')"
                    maxlength="11"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="付款方式" prop="payType">
                  <el-select
                    v-model="sellWaterForm.payType"
                    placeholder=""
                    clearable
                  >
                    <el-option
                      v-for="item in payTypeOptions"
                      :key="item.key"
                      :label="item.value"
                      :value="item.key"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="备注" prop="remark">
                  <el-input
                    v-model="sellWaterForm.remark"
                    placeholder=""
                    clearable
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>

        <div style="margin-top: 20px; text-align: center">
          <el-button type="primary" @click="sellWaterClick">售水</el-button>
          <!-- <el-button type="primary" plain>返回</el-button> -->
        </div>
      </div>
    </el-card>
    <!-- 打印信息提示 -->
    <el-dialog title="提示" :visible.sync="printInfoDialogVis" width="30%">
      <span>是否打印单据？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelPrint">取 消</el-button>
        <el-button type="primary" @click="printCredential">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  selectValidLessee,
  selectDictionaryListByName,
} from '../../api/comboboxLoad';
import dictionaryConstant from '../../constant/dictionaryConstant';
import {
  OfflineCharge,
  selectOneByLesseeId,
} from '../../api/water/addSellWater';
import { NumberSub } from '../../untils/func';
export default {
  data() {
    return {
      printInfoDialogVis: false,
      merchantNameOptions: [],
      payTypeOptions: [],
      sellWaterForm: {
        lesseeId: '',
        collectAmount: '',
        money: '',
        changeAmount: '',
        payType: '',
        remark: '',
      },
      sellWaterFormRules: {
        lesseeId: [
          { required: true, message: '请选择商户名称', trigger: 'change' },
        ],
        payType: [
          { required: true, message: '请选择付款方式', trigger: 'change' },
        ],
        collectAmount: [
          {
            required: true,
            trigger: 'blur',
            message: '请输入支付金额',
          },
          {
            pattern:
              /(^([-+])?[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^([-+])?[0-9]\.[0-9]([0-9])?$)/,
            message: '请输入正确金额格式,可保留两位小数',
          },
        ],
        money: [
          {
            required: true,
            trigger: 'blur',
            message: '请输入售水金额',
          },
          {
            pattern:
              /(^([-+])?[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^([-+])?[0-9]\.[0-9]([0-9])?$)/,
            message: '请输入正确金额格式,可保留两位小数',
          },
        ],
      },
      contentForm: {
        code: '',
        name: '',
        contactMan: '',
        systemAdmin: '',
        phone: '',
        systemAdminPhone: '',
        address: '',
        type: '',
        electricBalance: '',
        waterBalance: '',
        districtId: '',
      },
      orderNo: '',
    };
  },
  created() {
    this.init();
  },
  mounted() {},
  watch: {
    'sellWaterForm.collectAmount': {
      handler(newVal) {
        if (newVal == '' || newVal == null) {
          this.sellWaterForm.changeAmount = '';
        }
        if (newVal && this.sellWaterForm.money) {
          this.sellWaterForm.changeAmount = NumberSub(
            newVal,
            this.sellWaterForm.money
          );
        }
      },
    },
    'sellWaterForm.money': {
      handler(newVal) {
        if (newVal == '' || newVal == null) {
          this.sellWaterForm.changeAmount = '';
        }
        if (this.sellWaterForm.collectAmount && newVal) {
          this.sellWaterForm.changeAmount = NumberSub(
            this.sellWaterForm.collectAmount,
            newVal
          );
        }
      },
    },
  },
  methods: {
    async init() {
      await this.getSelectLessee();
      await this.getPayType();
    },

    async lesseeIdChange() {
      if (this.sellWaterForm.lesseeId) {
        const res = await selectOneByLesseeId({
          id: this.sellWaterForm.lesseeId,
        }).then();
        this.contentForm = res.data;
      }
    },

    sellWaterClick() {
      this.$refs.sellWaterForm.validate(async (valid) => {
        if (valid) {
          let params = {
            lesseeId: this.sellWaterForm.lesseeId,
            money: this.sellWaterForm.money, //售电金额
            payType: this.sellWaterForm.payType, //付款方式
            remark: this.sellWaterForm.remark,
          };
          const res = await OfflineCharge(params).then();
          this.orderNo = res.data;
          this.msgSuccess('售水成功');
          this.printInfoDialogVis = true;
        } else {
          this.msgError('信息填写错误');
          return false;
        }
      });
    },
    // 获取商户下拉列表数据
    async getSelectLessee() {
      const res = await selectValidLessee().then();
      this.merchantNameOptions = res.data;
    },
    // 获取付款方式 下拉列表
    async getPayType() {
      const res = await selectDictionaryListByName(
        dictionaryConstant.PAY_TYPE
      ).then();
      this.payTypeOptions = res.data;
    },

    // 取消打印
    cancelPrint() {
      this.printInfoDialogVis = false;
      this.sellWaterForm = {};
    },
    // 打印凭证
    async printCredential() {
      let params = [];
      params.push(this.orderNo);
      let routeData = this.$router.resolve({
        path: '/PrintViewWater',
        query: {
          multipleSelection: JSON.stringify(params),
          serviceFeeColumnName: this.$root.serviceFeeNameWater
        },
      });
      window.open(routeData.href, '_blank');
      this.printInfoDialogVis = false;

      this.sellWaterForm = {};
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding: 0 10px;
  height: 100%;
}
/deep/ .el-card__header {
  background-color: var(--secondColor) !important;
  color: var(--whiteColor);
}
@media screen and (max-width: 1000px) {
  .centerBox {
    width: 100% !important;
  }
}
.centerBox {
  width: 70%;
  margin: 0 auto;
  padding-top: 20px;
}

/deep/ .el-select {
  width: 100%;
}
/deep/ .el-form-item {
  margin-bottom: 10px;
}
.center_Con {
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 20px;
  margin: 15px 0;
}
.el-row {
  line-height: 30px;
}
/deep/ .el-form-item__label {
  font-size: 16px !important;
}
</style>
